module.exports = __webpack_public_path__ + "img/step_3.a09d04af.png";